import { render, staticRenderFns } from "./UpdateUserPassword.vue?vue&type=template&id=1ca54fae"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=js"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports